// extracted by mini-css-extract-plugin
export default {"rippleWrapper":"_m5Bo7UQVFuoZAOcuA4a","ripple":"zT0idlvIejE_dEcH9co_","rippleRestarting":"uTBgEvUFnwZGo92ZokfA","rippleActive":"aGB6AQ6hAlyJ9N0hhBIy"};